import { ContactUs } from '@/components/LandingPage/ContactUs';
import styles from '../../HomepageSections.module.scss';

export const ContactSection = () => (
  <div className={styles.contactSection}>
    <div className={styles.wideShell}>
      <ContactUs />
    </div>
  </div>
);
